<template>
  <div id="orderApp">
    <homeView />
  </div>
</template>

<script>
import homeView from './components/homeView'

export default {
  name: 'App',
  components: {
    homeView
  }
}
</script>

<style>
/* 样式可根据自己的需要进行修改 */
#orderApp {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  color: aliceblue;
}
body{
  background: url(./assets/1-2.jpg);
  margin: 0 auto;
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>